export var selectQuickSellInfo = function () {
    return;
};
export var selectQuickSellProductsInfo = function (state) {
    return state.quickSellInfo.productInfo;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectQuickSellInfo.ts
// module id = 830
// module chunks = 3